import { StaticImage } from "gatsby-plugin-image";
import { Link, useTranslation } from 'gatsby-plugin-react-i18next';
import React from "react";
import CookieConsent, { Cookies } from "react-cookie-consent";
import styled from "styled-components";
import LanguageSelectorComponent from '../components/language-selector';
import SocialsHeader from "../components/socials-header";

const HeaderWrapper = styled.header`
  position: fixed;
  display: block;
  top: 0px;
  width: 100%;
  color: #4FBC61;
  z-index: 99;
  height: 76px;
  background-color: rgba(255, 255, 255, 0.55);
  backdrop-filter: saturate(140%) blur(6px);
  -webkit-backdrop-filter: saturate(140%) blur(6px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.3s ease, background-color 0.3s ease, height 0.2s ease;

  &.scrolled {
    background-color: rgba(255, 255, 255, 0.72);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  }

  @media (max-width: 600px) {
    height: 64px;
  }
`;

const HeaderContainer = styled.div`
  max-width: 1560px;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 32px;

  @media (max-width: 600px) {
    padding: 0 20px;
  }

  @media (min-width: 2520px) {
    padding-right: 10%;
  }
`

const YellowColor = styled.span`
  color: #D4DE29;
`
const WebsiteTitle = styled.p`
  font-size: 23px;
  font-weight: 500;
  margin: 0;
  letter-spacing: -0.5px;
  text-decoration: none;
  color: inherit;
  line-height: 1;

  @media (max-width: 600px) {
      font-size: 20px;
  }
`;

const Logo = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`

const TreeImg = styled.div`
  width: 44px;
  display: flex;
  align-items: center;

  @media (max-width: 600px) {
      width: 32px;
  }
`

const NavGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  @media (max-width: 600px) {
    gap: 14px;
  }
`

const WebsiteLinks = styled.ul`
  display: flex;
  align-items: center;
  list-style-type: none;
  margin: 0;
  padding: 0;
  gap: 8px;
`;

const LinksLi = styled.li`
  display: flex;
  align-items: center;
  margin: 0;

  a {
    color: #1a1a1a;
    text-decoration: none;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: -0.2px;
    height: 40px;
    padding: 0 20px;
    border-radius: 999px;
    transition: background-color 0.2s ease, color 0.2s ease;
    display: inline-flex;
    align-items: center;
  }

  a:hover {
    background-color: rgba(79, 188, 97, 0.12);
    color: #4FBC61;
  }
`;

const Header = () => {
  const [offset, setOffset] = React.useState(0)
  const [concent, setConcent] = React.useState(true);
  const { t } = useTranslation();

  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    const handleScroll = () => setOffset(window.pageYOffset);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [])


  const declineCookies = () => {
    Cookies.remove("_ga");
    Cookies.remove("_gat");
    Cookies.remove("_gid");
    Cookies.remove("spring-tree-analytics-cookie");

    if (window) window[`ga-disable-${process.env.GOOGLE_ANALYTICS_ID}`] = true;
    localStorage.setItem('analytics-cookie', false);
  }


  React.useEffect(() => {
    const lsConcent = localStorage?.getItem('analytics-cookie');
    setConcent(lsConcent);
  }, [])
  return (
    <div>
      <SocialsHeader />
      <HeaderWrapper className={offset > 0 ? 'scrolled' : ''}>
        <HeaderContainer>
          <Logo>
            <Link to="/" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center', gap: 8 }}>
              <WebsiteTitle>Spring<YellowColor>Tree</YellowColor></WebsiteTitle>
              <TreeImg>
                <StaticImage loading="eager" placeholder="none" quality="100" src="../images/springtree-logo.png" alt="logo" />
              </TreeImg>
            </Link>
          </Logo>

          <NavGroup>
            <WebsiteLinks>
              <LinksLi>
                <Link style={{ cursor: 'pointer' }} to="/blog">Blog</Link>
              </LinksLi>
            </WebsiteLinks>
            <LanguageSelectorComponent />
          </NavGroup>
        </HeaderContainer>

        {concent === 'false' ? <></> : (<CookieConsent
          location="bottom"
          buttonText={t("accept.continue")}
          cookieName="spring-tree-analytics-cookie"
          style={{ background: "#493829" }}
          buttonStyle={{ background: "#1e954f", color: "white", fontSize: "14px", borderRadius: 6, height: 40, minWidth: 150 }}
          expires={150}
          onDecline={declineCookies}
          declineButtonText={t("decline")}
          enableDeclineButton={true}
          declineButtonStyle={{ color: "white", fontSize: "14px", borderRadius: 6, height: 40, width: 130, minWidth: 150 }}
        >
          <span style={{ fontSize: "16px", }}>{t("we.use.cookies")}</span>
        </CookieConsent>)}

      </HeaderWrapper>
    </div>

  );
};



export default Header;
